export default __webpack_public_path__ + "static/media/copy.00bfe510.vert";